import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import AuthCard from './components/AuthCard';
import RoleSelector from './components/RoleSelector';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import TrustBadges from './components/TrustBadges';
import ForgotPasswordModal from './components/ForgotPasswordModal';

const LoginScreen = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState('influencer');
  const [isSignup, setIsSignup] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <>
      <Helmet>
        <title>Login - SocialCents</title>
        <meta name="description" content="Sign in to SocialCents to earn cashback by sharing your purchases or connect with influencers as a brand partner" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="w-full max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="hidden lg:block">
              <div className="space-y-6">
                <h1 className="text-4xl lg:text-5xl font-bold text-foreground">
                  Turn Your Purchases Into{' '}
                  <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                    Rewards
                  </span>
                </h1>
                <p className="text-lg text-muted-foreground">
                  Join thousands of creators earning cashback by sharing their authentic purchase experiences on social media.
                </p>
                <div className="grid grid-cols-2 gap-4 pt-4">
                  <div className="p-4 rounded-xl bg-card/50 border border-border">
                    <div className="text-3xl font-bold text-primary mb-2">$2.5M+</div>
                    <div className="text-sm text-muted-foreground">Rewards Paid</div>
                  </div>
                  <div className="p-4 rounded-xl bg-card/50 border border-border">
                    <div className="text-3xl font-bold text-secondary mb-2">50K+</div>
                    <div className="text-sm text-muted-foreground">Active Creators</div>
                  </div>
                  <div className="p-4 rounded-xl bg-card/50 border border-border">
                    <div className="text-3xl font-bold text-accent mb-2">500+</div>
                    <div className="text-sm text-muted-foreground">Brand Partners</div>
                  </div>
                  <div className="p-4 rounded-xl bg-card/50 border border-border">
                    <div className="text-3xl font-bold text-success mb-2">4.9★</div>
                    <div className="text-sm text-muted-foreground">User Rating</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <AuthCard
                title={isSignup ? 'Create Account' : 'Welcome Back'}
                subtitle={isSignup ? 'Start earning rewards today' : 'Sign in to continue'}
              >
                <div className="space-y-6">
                  {isSignup && (
                    <RoleSelector
                      selectedRole={selectedRole}
                      onRoleChange={setSelectedRole}
                    />
                  )}

                  {isSignup ? (
                    <SignupForm selectedRole={selectedRole} />
                  ) : (
                    <LoginForm
                      onForgotPassword={() => setShowForgotPassword(true)}
                    />
                  )}

                  <div className="text-center">
                    <button
                      onClick={() => setIsSignup(!isSignup)}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {isSignup ? (
                        <>
                          Already have an account?{' '}
                          <span className="text-primary font-medium">Sign In</span>
                        </>
                      ) : (
                        <>
                          Don&apos;t have an account?{' '}
                          <span className="text-primary font-medium">Create Account</span>
                        </>
                      )}
                    </button>
                  </div>

                  <TrustBadges />
                </div>
              </AuthCard>
            </div>
          </div>
        </div>
      </div>

      <ForgotPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
      />
    </>
  );
};

export default LoginScreen;